// extracted by mini-css-extract-plugin
export var chevron = "_2h-2";
export var chevronCollapsed = "_2h-3";
export var collapsibleHeader = "_2h-1";
export var container = "_2h-0";